// Small pure helpers for the signed-in user. Kept out of components so they
// can be unit-tested with `node src/lib/user.test.mjs`.

// Avatar initials: first+last initial for multi-word names, first two letters
// for a single word, "?" when empty.
export function initialsFromName(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

// Human label for a role. Falls back to "User" when absent.
export function roleLabel(role) {
  if (!role) return 'User'
  return role.charAt(0).toUpperCase() + role.slice(1)
}

// Only admins may resolve Approvals.
export const isAdmin = (user) => user?.role === 'admin'
